module.exports = __webpack_public_path__ + "static/car-cover-ed79d7d3deadae4a8770c122475ba23d.jpg";